import * as check from 'check-types';
function getJson(context) {
    try {
        return JSON.stringify(context);
    }
    catch (err) {
        return ('{' +
            Object.keys(context)
                .map((key) => key + ': ' + context[key])
                .join(', ') +
            '}');
    }
}
const makeFailer = function (typeCheck, msg) {
    return function (x, name, context) {
        if (!typeCheck(x)) {
            const xtraMessage = (() => {
                if (!context) {
                    return '';
                }
                const contextValue = typeof context === 'function' ? context() : context;
                return ', context:' + getJson(contextValue);
            })();
            throw new Error('Expected variable ' +
                (name ? name : 'UNKNOWN') +
                ' to be of type ' +
                msg +
                " but found type '" +
                (x ? x.constructor.name : 'undefined') +
                "' and value: " +
                (x ? JSON.stringify(x) : 'undefined') +
                xtraMessage);
        }
    };
};
const checkInstance = function (prototype) {
    const checker = function (obj) {
        return obj.constructor === prototype;
    };
    return checker;
};
check.number.orFail = makeFailer(check.number, 'number');
check.function.orFail = makeFailer(check.function, 'function');
check.boolean.orFail = makeFailer(check.boolean, 'bool');
check.string.orFail = makeFailer(check.string, 'string');
check.object.orFail = makeFailer(check.object, 'object');
check.date.orFail = makeFailer(check.date, 'date');
check.array.of.object.orFail = makeFailer(check.array.of.object, 'array.of.object');
check.array.of.number.orFail = makeFailer(check.array.of.number, 'array.of.number');
check.array.of.string.orFail = makeFailer(check.array.of.string, 'array.of.string');
check.array.orFail = makeFailer(check.array, 'array');
check.undefined.orFail = makeFailer((x) => x === undefined, 'undefined');
check.instanceOf = function (prototype) {
    return {
        orFail: makeFailer(checkInstance(prototype), prototype.name),
    };
};
export default check;
